export default {
  global: {
    send: 'Send',
    save: 'Save',
    confirm: 'Confirm',
    cancel: 'Cancel',
    brand: 'HeiGIT - Heidelberg University',
    close: 'Close',
    closeAndDoNotShowAgain: 'Close and do not show again',
    select: 'Select',
    yes: 'Yes',
    no: 'No',
    and: 'and',
    noAndDonAskAgain: 'NO (don`t ask again)',
    ok: 'OK',
    polygon: 'polygon',
    developedByIntro: 'Services developed by',
    developedBy: 'HeiGIT gGmbH',
    duration: 'Duration',
    distance: 'Distance',
    elevation: 'Elevation',
    profile: 'Profile',
    options: 'Options',
    parameters: 'Parameters',
    custom: 'Custom',
    customOverlayer: 'Custom overlayer',
    rawRouting: 'Raw routing',
    months: {
      january: 'January',
      february: 'February',
      march: 'March',
      april: 'April',
      may: 'May',
      june: 'June',
      july: 'July',
      august: 'August',
      september: 'September',
      october: 'October',
      november: 'November',
      december: 'December'
    },
    monthsShort: {
      january: 'Jan',
      february: 'Feb',
      march: 'Mar',
      april: 'Apr',
      may: 'May',
      june: 'Jun',
      july: 'Jul',
      august: 'Aug',
      september: 'Sep',
      october: 'Oct',
      november: 'Nov',
      december: 'Dec'
    },
    units: {
      km: 'km(s)',
      mi: 'mi(s)',
      m: 'm',
      seconds: 'seconds',
      s: 's',
      minutes: 'minutes',
      hours: 'hour(s)',
      days: 'd',
      h: 'h',
      min: 'min',
      meters: 'meters',
      lat: 'lat',
      lng: 'long',
      tones: 'tones',
      t: 't',
      kmh: 'km/h'
    },
    layers: {
      macrocounty: 'Macro county',
      country: 'Country',
      region: 'Region',
      county: 'County',
      macroregion: 'Macro region',
      neighbourhood: 'Neighbourhood',
      locality: 'Locality',
      borough: 'Borough',
      localadmin: 'Local admin',
      address: 'Address',
      street: 'Street',
      venue: 'Venue',
      rawCoordinate: 'Raw lng,lat coordinates',
      notAvailable: 'Not available',
      postalcode: 'Postal code',
      'undefined': 'Not defined',
      ocean: 'Ocean'
    },
    population: 'Population',
    green: 'Green',
    noise: 'Noise',
    steepness: 'Steepness',
    surface: 'Surface',
    roadaccessrestrictions: 'Road access restrictions',
    waytype: 'Way type',
    suitability: 'Suitability',
    waycategory: 'Way category',
    tollways: 'Tollways',
    traildifficulty: 'Trail difficulty',
    osmid: 'OSM ID',
    countryinfo: 'Country info',
    csv: 'Heat stress' // HEAL api
  }
}
